import React, { useState, useEffect } from 'react';
import { FaChevronUp } from 'react-icons/fa';

const ScrollToTop = () => {
    const [isVisible, setIsVisible] = useState(false);

    // Show button when page is scrolled down
    const toggleVisibility = () => {
        if (window.pageYOffset > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    // Set the top scroll behavior
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    useEffect(() => {
        window.addEventListener('scroll', toggleVisibility);
        return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);

    return (
        <div className="fixed bottom-10 right-10 z-[999]">
            {isVisible && (
                <button
                    onClick={scrollToTop}
                    className="group relative w-14 h-14 bg-[#007bff] hover:bg-[#002147] text-white rounded-full flex items-center justify-center shadow-2xl transition-all duration-500 hover:scale-110 active:scale-95"
                    aria-label="Scroll to top"
                >
                    {/* Pulsing Ring Animation */}
                    <span className="absolute inset-0 rounded-full bg-[#007bff] opacity-20 animate-ping group-hover:hidden"></span>

                    {/* Medical Plus Cross Decoration (Subtle) */}
                    <div className="absolute -top-1 -right-1 w-5 h-5 bg-white text-[#007bff] rounded-md flex items-center justify-center text-[10px] font-bold shadow-md border border-[#007bff]/20">
                        +
                    </div>

                    <FaChevronUp className="text-xl group-hover:-translate-y-1 transition-transform duration-300" />
                </button>
            )}
        </div>
    );
};

export default ScrollToTop;
